import styled from 'styled-components';

import { Box } from 'Components/Base';

const ExamItemWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.colors.backgroundNeutralLightgrey};
  width: 100%;
  border-radius: 16px;
  opacity: 1;
  &.fade-item.fade-in {
    transition: opacity 0.5s ease;
    opacity: 1;
  }
  &.fade-item.fade-out {
    opacity: 0;
  }
`;

export default ExamItemWrapper;
